import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { filter, map, take } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for loading to finish (APP_INITIALIZER to complete)
  return authService.isLoading$.pipe(
    filter(isLoading => !isLoading), // Wait until loading is done
    take(1), // Take only the first emission after loading is done
    map(() => {
      const isAuthenticated = authService.isAuthenticatedSubject.value;
      console.log('AuthGuard: Loading complete. Authenticated:', isAuthenticated);

      if (!isAuthenticated) {
        console.log('Not authenticated, redirecting to login...');
        authService.login().subscribe();
        return false;
      }

      console.log('User is authenticated, allowing access');
      return true;
    })
  );
};
